'use client';

import { useFormState, useFormStatus } from 'react-dom';

import { Button } from '~/components/ui/button';
import { Input } from '~/components/ui/input';
import { Label } from '~/components/ui/label';
import { type ResetState, requestPasswordReset } from '~/lib/auth/reset-actions';

const initialState: ResetState = {};

export function RequestResetForm() {
  const [state, formAction] = useFormState(requestPasswordReset, initialState);

  if (state.ok) {
    return (
      <div className="mt-8 rounded-[4px] border border-[color:var(--border-subtle)] bg-[color:var(--bg-panel)] px-3 py-3 text-sm text-[color:var(--fg-secondary)]">
        If an account exists for that email, a reset link is on its way. The link is valid for one
        hour.
      </div>
    );
  }

  return (
    <form action={formAction} className="mt-8 space-y-4">
      <div className="space-y-1.5">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
          aria-invalid={state.fieldErrors?.email ? 'true' : undefined}
        />
        {state.fieldErrors?.email ? (
          <p className="text-xs text-[color:var(--color-error)]">{state.fieldErrors.email}</p>
        ) : null}
      </div>
      <Submit />
    </form>
  );
}

function Submit() {
  const { pending } = useFormStatus();
  return (
    <Button type="submit" variant="primary" className="w-full" disabled={pending}>
      {pending ? 'Sending…' : 'Send reset link'}
    </Button>
  );
}
